import React from 'react';
import DocumentTitle from 'react-document-title';
import { injectIntl } from 'react-intl';
import {
  Table,
  TableHeader,
} from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import { connect } from 'react-redux';
import { useAllManageLeaseExpirations } from './hooks';
import LeaseInfoCards from './LeaseInfoCards';
import TableLayout from '../../components/TableLayout';
import useBaseTableProps from '../../hooks/useBaseTableProps';

const NAME = 'centralized-lease-expirations';
const TITLE = 'Manage Expiring Leases';
function AllManageLeaseExpirations({ intl, organizationId }) {
  const [selectedMetric, setSelectedMetric] = React.useState(null);
  function handleChange(metric) {
    setSelectedMetric((prevMetric) => {
      return prevMetric === metric ? null : metric;
    });
  }

  const baseTableProps = useBaseTableProps();
  const {
    allColumnsHidden,
    columnOptions,
    count,
    dateState,
    filterState,
    filterTypeState,
    filteredHeaders,
    handleColumnChange,
    handleDateSubmit,
    handleFilterChange,
    handleFilterTypeChange,
    handleSearchSubmit,
    handleSortChange,
    isLoading,
    name,
    onCSVButtonClick,
    order,
    orderBy,
    rows,
    searchState,
    selectedColumns,
    totalCount,
    metrics,
  } = useAllManageLeaseExpirations({
    NAME,
    organizationId,
    selectedMetric,
  });

  return (
    <DocumentTitle data-testid={NAME} title={TITLE}>
      <TableLayout name={name} childrenElementsHeight={50 + 8 + 178}>
        {(tableHeight) => (
          <>
            <TableHeader title={TITLE} count={count} totalCount={totalCount} />
            <LeaseInfoCards
              metrics={metrics}
              onChange={handleChange}
              selectedMetric={selectedMetric}
            />
            <Table
              {...baseTableProps}
              allColumnsHidden={allColumnsHidden}
              columnOptions={columnOptions}
              count={count}
              dateState={dateState}
              filterState={filterState}
              filterTypeState={filterTypeState}
              handleColumnChange={handleColumnChange}
              handleDateSubmit={handleDateSubmit}
              handleFilterChange={handleFilterChange}
              handleFilterTypeChange={handleFilterTypeChange}
              handleSearchSubmit={handleSearchSubmit}
              handleSortChange={handleSortChange}
              headers={filteredHeaders}
              height={tableHeight}
              isLoading={isLoading}
              name={name}
              onCSVButtonClick={onCSVButtonClick}
              order={order}
              orderBy={orderBy}
              rows={rows}
              searchState={searchState}
              selectedColumns={selectedColumns}
              totalCount={totalCount}
            />
          </>
        )}
      </TableLayout>
    </DocumentTitle>
  );
}

const mapStateToProps = (state: Object): Object => {
  const {
    app: { currentUser },
  } = state;
  return {
    organizationId: currentUser?.user?.organization?.id ?? '',
  };
};

export default connect(mapStateToProps)(injectIntl(AllManageLeaseExpirations));
